export function formatDate(date, includeTime = false) {
  const dateObj = date instanceof Date ? date : new Date(date);
  
  if (includeTime) {
    return new Intl.DateTimeFormat("sr-RS", {
      year: "numeric",
      month: "2-digit",
      day: "2-digit",
      hour: "2-digit",
      minute: "2-digit",
      hour12: false,
    }).format(dateObj);
  }
  
  return new Intl.DateTimeFormat("sr-RS", {
    year: "numeric",
    month: "2-digit",
    day: "2-digit",
  }).format(dateObj);
}

export function getAllowedRoles() {
  return ["ROLE_ADMIN", "ROLE_USER", "ROLE_MODERATOR", "ROLE_FAKTURISTA", "ROLE_MAGACIONER"];
}

export const phoneNumberRegEx = /^\+\d{3}\d{8}$/;

export function formatNumber(number) {
  return <span>{Number(number).toFixed(2).replace(/\d(?=(\d{3})+\.)/g, '$&,')} RSD</span>
}

export function formatNumberKG(number) {
  return <span>{Number(number).toFixed(2).replace(/\d(?=(\d{3})+\.)/g, '$&,')} KG</span>
}

export function discountedPrice(price, discount) {
  return (Number(price) * (1 - Number(discount / 100)).toFixed(2));
}

export function priceWithPDV(price, discount) {
  return (Number(price) * (1 + Number(discount / 100)).toFixed(2));
}

// New function for percentage-based discount calculation with additive logic
export function calculateFinalPrice(wholesalePrice, articleDiscountPercent, customerDiscountPercent, pdv) {
  const totalDiscount = (Number(articleDiscountPercent || 0) + Number(customerDiscountPercent || 0)) / 100;
  const priceAfterDiscount = Number(wholesalePrice) * (1 - totalDiscount);
  const finalPrice = priceAfterDiscount * (1 + Number(pdv || 0) / 100);
  return finalPrice;
}

// Calculate price with discount (no PDV)
export function calculatePriceWithDiscount(wholesalePrice, articleDiscountPercent, customerDiscountPercent) {
  const totalDiscount = (Number(articleDiscountPercent || 0) + Number(customerDiscountPercent || 0)) / 100;
  return Number(wholesalePrice) * (1 - totalDiscount);
}

export function formatNumberWithoutPostfix(number) {
  return <span>{Number(number).toFixed(2).replace(/\d(?=(\d{3})+\.)/g, '$&,')}</span>
}

export const removeSpecialCharacters = (text) => {
  if (!text) return text;
  const specialChars = {
    'š': 's',
    'Š': 'S',
    'đ': 'dj',
    'Đ': 'Dj',
    'ž': 'z',
    'Ž': 'Z',
    'č': 'c',
    'Č': 'C',
    'ć': 'c',
    'Ć': 'C',
    '_': ' ',
  };
  return text.replace(/[šŠđĐžŽčČćĆ_]/g, (match) => specialChars[match] || match);
};

// Influencer customer type helpers
export const isInfluencerCustomer = (customer) => {
  return customer?.customerType === 'INFLUENCER';
};

// Format currency with Serbian locale (2 decimal places)
export const formatCurrency = (value) => {
  return Number(value || 0).toLocaleString('sr-RS', {
    minimumFractionDigits: 2,
    maximumFractionDigits: 2
  });
};

// Get utilization/progress bar color based on percentage
export const getUtilizationColor = (percentage) => {
  if (percentage < 50) return 'bg-green-500';
  if (percentage < 80) return 'bg-yellow-500';
  return 'bg-red-500';
};

// Calculate influencer price (full price with PDV, no discounts)
export const calculateInfluencerPrice = (wholesalePrice, pdv) => {
  return Number(wholesalePrice) * (1 + Number(pdv || 0) / 100);
};
